import { riskyAddressCountLine } from '../sendGuardCopy';
import { ReviewMailCard } from './ReviewMailCard';
import type { BatchDraftItem } from './useBatchDrafts';
import { effectiveRecipient } from './wizardState';

type ReadyItem = Extract<BatchDraftItem, { state: 'ready' }>;

export interface RiskyDraftsProps {
  /** This batch's ready drafts; only the ones an address guard flagged are shown. */
  items: ReadyItem[];
  /** The viewer is an admin: the count line says they can send a held email anyway from its thread. */
  canSendAnyway?: boolean;
}

/** Discovr #742: drafts bound for a risky address are held by the batch send. */
export function RiskyDrafts({ items, canSendAnyway = false }: RiskyDraftsProps) {
  const flagged = items.filter((item) => item.draft.message.addressGuard);
  if (flagged.length === 0) return null;
  return (
    <section aria-label="Risky addresses" className="space-y-3">
      <p className="rounded-xl border border-amber-200 bg-amber-50 px-4 py-2 text-body-sm-medium text-amber-900">{riskyAddressCountLine(flagged.length, { canSendAnyway })}</p>
      <ul className="space-y-4">
        {flagged.map((item) => (
          <li key={item.entryId} className="list-none">
            <ReviewMailCard draft={item.draft} to={effectiveRecipient(item.draft)} />
          </li>
        ))}
      </ul>
    </section>
  );
}
